import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import ArticlesTemplate from '@components/Articles/Articles';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import {IS_PROD, ROUTES, TRAININGS_LIMIT_PER_PAGE} from '../constants';
import { IArticleItem } from '../interfaces/Article';
import { FilterTypesInUrl } from '../interfaces/Filter';
import { articleApi } from '../services/article.service';
import {Title} from "@components/Trainings/Trainings.elements";
import {useRouter} from "next/router";

interface IBlog {
    status: number;
    articlesCount: number;
    articles: IArticleItem[];
}

const Blog: NextPage<IBlog> = (props) => {
    const { t } = useTranslation();

    const router = useRouter();

    return (
        <>
            <NextSeo
                title={t('seo.blog.title')}
                description={t('seo.blog.description')}
                noindex={!IS_PROD}
                nofollow={!IS_PROD}
            />
            <HeaderTemplate />
            <ContentTemplate withPadding mobileSidePadding={20}>
                <Title withMargin={!router.pathname.includes(ROUTES.MY_PV)}>{t('blog.title')}</Title>
                <ArticlesTemplate articles={props?.articles} count={props.articlesCount} />
            </ContentTemplate>
            <FooterTemplate />
        </>
    );
};

Blog.getInitialProps = async (ctx) => {
    try {
        const { query } = ctx;

        const { data } = await articleApi.list(
            TRAININGS_LIMIT_PER_PAGE,
            query[FilterTypesInUrl.PAGE] ? (Number(query[FilterTypesInUrl.PAGE]) - 1) * TRAININGS_LIMIT_PER_PAGE : 0
        );

        return {
            status: 200,
            articlesCount: data?.total_count,
            articles: data?.results,
        };
    } catch (error) {
        return {
            status: 500,
            articlesCount: 0,
            articles: [],
        };
    }
};

export default Blog;
